var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_227_1157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.55,
    height: 17,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_227_1157)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.40039,
    y: -5.1001,
    width: 26.35,
    height: 26.35,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_227_1157",
    transform: "matrix(0.025641 0 0 0.0294872 0 -0.00128203)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_227_1157",
    width: 39,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAiCAYAAADcbsCGAAAABHNCSVQICAgIfAhkiAAAAYlJREFUWEftmEFSg0AQRfvjThfmBnIDuYFxyyrmArKmUmVuYDxBWKTcihdQVriNN9AbxBtkH4u2oUoDgQgzAUNFWEL38Ob/np4BkOZ1ZY/mAF1oppemRaBLlEZtCejgDlU5TyZm6U4unQdik4Cz9L2daq4OqO8xhvZoQqDbDk5V1cNVbtAf94K5t1RVpGq8lnIxlHG8mhLh4ymcTaq+TDVOGW5guxYIDwAsYrprDdzQdh2GMZW9rZeo0Aa4HxsBJ2PNvuEyNm4UDTMvpIMvVGupMJ7p/TmcjdPPfq25nI21UBQPwkyvAtevBCdHH0/OZTcN8mQrRAUusROGL8V//heASsrFQPFCwMnKk9Zx3TSgMtz6dODKKoUnxX+ahmTiRwb8WsCjaBmE92+Vam7zhYU277uVpCFzNrcJLmezWN2a7SujoqxmYsMMXmZBLTVXMIjyxt8USNG4HZyu2v9LuaQf8lGmWesqB0SONH7ZANbXTt+t3b8SXSs65XSVi0/PRIapm1+WF0Wf/hfyLd6LTobBFgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.51d67798084f20e9868faa40f827995e.svg";
export { ForwardRef as ReactComponent };